import React, { useCallback, useState } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { Tappable } from '@vectord/components';
import classNames from 'classnames';

import Field from 'components/Field';
import Input from 'components/Input';
import styles from './SelectMenteePage.module.scss';
import NavBar from 'components/NavBar';

function SelectMenteePage() {
  const navigate = useNavigate();
  const [email, setEmail] = useState();

  const handleKeyEnter = useCallback(
    (event) => {
      if (event.key === 'Enter') {
        navigate(email);
      }
    },
    [email, navigate]
  );

  const handleOnClick = useCallback(() => {
    navigate(email);
  }, [email, navigate]);

  const handleOnChange = useCallback((event) => {
    setEmail(event.target.value);
  }, []);

  return (
    <>
      <NavBar
        title="MODULE MANAGEMENT TOOL"
        id="module-management"
        homeUrl="/"
        className="p-xs"
      />
      <div className="p-l">
        <Field
          label="Search Learner / Mentee"
          className="no-wrap"
        >
          <Input
            placeholder="Learner's Email ID"
            required
            onKeyDown={handleKeyEnter}
            onChange={handleOnChange}
            className={styles.input}
          />
          <Tappable
            onClick={handleOnClick}
            className={classNames('btn btn-primary btn-long', styles.tappable)}
          >
            Search
          </Tappable>
        </Field>
        <Outlet />
      </div>
    </>
  );
}

export default SelectMenteePage;
